import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'
import { InputMask } from 'primereact/inputmask';
import { selectInsuranceCompanyLife, selectInsuranceCompanyProperty, setProcessCalc, setStepCalc } from './calcSlice';
import UniversalDropDown from '../dropDown/unuversalDropDown'
import {
    JOBS,
    listAlcohol,
    listGender,
    listIsNewestBuilding,
    listIsPublicPerson, listPreassureBot,
    listPreassureUp,
    listSmoking,
    profs
} from "../../static/vars";
import {
    selectAlcohol,
    selectArteryBott,
    selectArteryUp,
    selectBirthDate,
    selectBirthDateString,
    selectHeight,
    selectIsNewest,
    selectIsPublicPerson,
    selectIssueDate,
    selectIssueDateString,
    selectIssuedBy,
    selectLastname,
    selectName,
    selectPatronymic,
    selectPosition,
    selectProfession,
    selectRegAdr,
    selectSerial,
    selectSex,
    selectSmoking,
    selectSubdivision,
    selectWeight,
    selectWorkingPlace,
    setAlcohol,
    setArteryBott,
    setArteryUp,
    setBirthDate,
    setBirthDateString,
    setFiasIdRegAddr,
    setHeight,
    setIsNewest,
    setIsPublicPerson,
    setIssueDate,
    setIssueDateString,
    setIssuedBy,
    setKladrIdRegAddr,
    setLastname,
    setName,
    setPatronymic,
    setPosition,
    setProfession,
    setRegAdr,
    setSerial,
    setSex,
    setSmoking,
    setSubdivision,
    setWeight,
    setWorkingPlace
} from "./personSlice";
import { AddressSuggestions } from "react-dadata";
import { FioSuggestions } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';
import { selectAddresObject } from "./objectSlice";
import CaseButton from "../caseButton/caseButton";
import { setDateBegin, setDateContract } from './contractSlice';
import { selectLifeOption, selectPropertyOption } from '../precalc/precalcSlice';


export function DataPerson() {
    const dispatch = useDispatch()

    const [emptyName, setEmptyName] = useState(true)
    const [emptyLastname, setEmptyLastname] = useState(true)
    const [emptyPatr, setEmptyPatr] = useState(true)
    const [emptyDate, setEmptyDate] = useState(true)
    const [emptyGender, setEmptyGender] = useState(true)
    const [emptyHeight, setEmptyHeight] = useState(true)
    const [emptyWeight, setEmptyWeight] = useState(true)
    const [emptySerial, setEmptySerial] = useState(true)
    const [emptyDateIss, setEmptyDateIss] = useState(true)
    const [emptySubdiv, setEmptySubdiv] = useState(true)
    const [emptyIss, setEmptyIss] = useState(true)
    const [emptyAddress, setEmptyAddress] = useState(true)
    const [emptyWorkingPlace, setEmptyWorkingPlace] = useState(true)
    const [status, setStatus] = useState(true)
    const [cyrylic, setCyrylic] = useState(true)
    const [age, setAge] = useState(true)
    const [issueBuyCorrect, setIssueBuyCorrect] = useState(true)
    const [addressQsymCorrect, setAddressQsymCorrect] = useState(true)
    const [correctBirthDate, setCorrectBirthDate] = useState(true);
    const [correctIssueDate, setCorrectIssueDate] = useState(true);

    const lifeOption = useSelector(selectLifeOption)
    const propertyOption = useSelector(selectPropertyOption)
    const name = useSelector(selectName)
    const lastname = useSelector(selectLastname)
    const patronymic = useSelector(selectPatronymic)
    const sex = useSelector(selectSex)
    const regAdr = useSelector(selectRegAdr)

    const height = useSelector(selectHeight)
    const weight = useSelector(selectWeight)

    const serial = useSelector(selectSerial)

    const subdivision = useSelector(selectSubdivision)
    const issuedBy = useSelector(selectIssuedBy)

    const insuranceCompanyProperty = useSelector(selectInsuranceCompanyProperty)
    const insuranceCompanyLife = useSelector(selectInsuranceCompanyLife)

    const issueDateString = useSelector(selectIssueDateString)
    const birthDateString = useSelector(selectBirthDateString)

    const handleNext = () => {
        window.ym(90426649,'reachGoal','zayemshik')
        dispatch(setProcessCalc('contract'))
        dispatch(setStepCalc('contract'))
        dispatch(setBirthDate(editDate(birthDateString)))
        dispatch(setIssueDate(editDate(issueDateString)))
    }

    const editDate = (value) => {
        let buf = value.split('.')
        let arr = [buf[1], buf[0], buf[2]]
        return new Date(arr.join('-'))
    }

    const handleClickNext = () => {
        console.log('handleClickNext', issuedBy)
        let good = true
        if (!checkFields()) {
            setStatus(false)
            good = false
            console.log('status')
        }
        else setStatus(true)

        if (!dateDiff()) {
            setAge(false)
            good = false
            console.log('age')
        }
        else setAge(true)

        if (!checkCyrylic()) {
            setCyrylic(false)
            good = false
            console.log('cyrilic')
        }
        else setCyrylic(true)

        if (!good) return
        handleNext()

    }

    const checkInsuranceCompanies = () => {
        if ((insuranceCompanyProperty === 'zetta' && propertyOption && insuranceCompanyLife !== 'vsk') || (insuranceCompanyLife === 'zetta' && lifeOption && insuranceCompanyProperty !== 'vsk')) {
            return 1
        } else if ((insuranceCompanyProperty === 'zetta' && insuranceCompanyLife === 'vsk') || (insuranceCompanyLife === 'zetta' && insuranceCompanyProperty === 'vsk')) {
            return 2
        } else if ((insuranceCompanyProperty !== 'zetta' && insuranceCompanyLife === 'vsk' && lifeOption) || (insuranceCompanyLife !== 'zetta' && insuranceCompanyProperty === 'vsk' && propertyOption)) {
            return 3
        }
    }

    const isIOSorMac = () => {
        const platform = navigator.platform.toLowerCase();
        return platform.includes('mac') || platform.includes('iphone') || platform.includes('ipad');
    };

    const dateDiff = () => {
        if (isIOSorMac()) {
            // Ваш код обработки для iOS и macOS
            // ...
            console.log('ios')
            return true;
        }
        let dt1 = new Date(editDate(issueDateString))
        let dt2 = new Date(editDate(birthDateString))
        var diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60 * 60 * 24);
        return Math.abs(Math.round(diff / 365.25)) >= 14
    }

    const checkCyrylic = () => {
        let arr = [0, 0, 0]
        if (name.search(/[A-z]/) !== -1) {
            setCyrylic(false)
            arr[0] = 0
        } else if (name.search(/[0-9]/) !== -1) {
            setCyrylic(false)
            arr[0] = 0
        } else {
            setCyrylic(true)
            arr[0] = 1
        }
        if (lastname.search(/[A-z]/) !== -1) {
            setCyrylic(false)
            arr[1] = 0
        } else if (lastname.search(/[0-9]/) !== -1) {
            setCyrylic(false)
            arr[1] = 0
        } else {
            setCyrylic(true)
            arr[1] = 1
        }
        if (patronymic.search(/[A-z]/) !== -1) {
            setCyrylic(false)
            arr[2] = 0
        } else if (patronymic.search(/[0-9]/) !== -1) {
            setCyrylic(false)
            arr[2] = 0
        } else {
            setCyrylic(true)
            arr[2] = 1
        }
        console.log('arr', arr)
        return arr.find((element) => element === 0) === undefined;
    }

    const checkDates = () => {
        console.log('checkDates', issueDateString)
        const arr_date = birthDateString.split('.')
        const arr_issue_date = issueDateString.split('.')
        console.log('checkBirthDate', arr_date, arr_issue_date)
        let is_correct = true
        if (parseInt(arr_date[0]) > 31 || parseInt(arr_date[1]) > 12 || parseInt(arr_date[2]) > 2010 || parseInt(arr_date[2]) < 1950) {
            setCorrectBirthDate(false)
            is_correct = false
        }
        else {
            setCorrectBirthDate(true)

        }

        if (parseInt(arr_issue_date[0]) > 31 || parseInt(arr_issue_date[1]) > 12 || parseInt(arr_issue_date[2]) > 2024 || parseInt(arr_issue_date[2]) < 1950) {
            setCorrectIssueDate(false)
            is_correct = false
        }
        else {
            setCorrectIssueDate(true)

        }
        console.log('is_correct', is_correct)
        return is_correct ? 1 : 0
    }

    const checkLastname = () => {
        if (lastname.replaceAll(' ', '') === "") {
            const inp = document.getElementById('lastname')
            if (inp.value.replaceAll(' ', '') === "") {
                setEmptyLastname(false)
                return 0
            }
            else {
                dispatch(setLastname(inp.value))
                setEmptyLastname(true)
                return 1
            }
        } else {
            setEmptyLastname(true)
            return 1
        }
    }

    const checkName = () => {
        if (name.replaceAll(' ', '') === "") {
            const inp = document.getElementById('name')
            if (inp.value.replaceAll(' ', '') === "") {
                setEmptyName(false)
                return 0
            }
            else {
                dispatch(setName(inp.value))
                setEmptyName(true)
                return 1
            }
        } else {
            setEmptyName(true)
            return 1
        }
    }

    const checkPatronymic = () => {
        if (patronymic.replaceAll(' ', '') === "") {
            const inp = document.getElementById('parentname')
            if (inp.value.replaceAll(' ', '') === "") {
                setEmptyPatr(false)
                return 0
            }
            else {
                dispatch(setPatronymic(inp.value))
                setEmptyPatr(true)
                return 1
            }
        } else {
            setEmptyPatr(true)
            return 1
        }
    }

    const checkBirthDate = () => {



        if (birthDateString.replaceAll(' ', '') === "") {
            setEmptyDate(false)
            return 0
        } else {
            setEmptyDate(true)
            return 1
        }
    }

    const checkSex = () => {
        if (sex.replaceAll(' ', '') == "") {
            setEmptyGender(false)
            return 0
        } else {
            setEmptyGender(true)
            return 1
        }
    }

    const checkHeight = () => {
        if (height.replaceAll(' ', '') === "" && lifeOption) {
            setEmptyHeight(false)
            return 0
        } else {
            setEmptyHeight(true)
            return 1
        }
    }

    const checkWeight = () => {
        if (weight.replaceAll(' ', '') === "" && lifeOption) {
            setEmptyWeight(false)
            return 0
        } else {
            setEmptyWeight(true)
            return 1
        }
    }

    const checkSerial = () => {
        if (serial.replaceAll(' ', '') == "") {
            setEmptySerial(false)
            return 0
        } else {
            setEmptySerial(true)
            return 1
        }
    }

    const checkIssueDate = () => {
        if (issueDateString.replaceAll(' ', '') == "") {
            setEmptyDateIss(false)
            return 0
        } else {
            setEmptyDateIss(true)
            return 1
        }
    }

    const checkSubdiv = () => {
        if (subdivision.replaceAll(' ', '') == "") {
            setEmptySubdiv(false)
            return 0
        } else {
            setEmptySubdiv(true)
            return 1
        }
    }

    const checkIssuedBy = () => {
        console.log('checkIssuedBy', issuedBy)
        if (issuedBy.replaceAll(' ', '') === "") {
            setEmptyIss(false)
            return 0
        }
        else if (issuedBy.trim().length < 6) {
            setIssueBuyCorrect(false)
            return 0
        }
        else {
            setEmptyIss(true)
            return 1
        }
    }

    const checkRegAdr = () => {
        if (regAdr === "") {
            setEmptyAddress(false)
            return 0
        }
        else if (regAdr.trim().length < 10) {
            setAddressQsymCorrect(false)
            return 0
        }
        else {
            setEmptyAddress(true)
            return 1
        }
    }

    const checkWorkingPlace = () => {
        if (workingPlace.replaceAll(' ', '') == "") {
            if (checkInsuranceCompanies() == 2 || checkInsuranceCompanies() == 1) {
                return true
            }
        } else if (checkInsuranceCompanies() !== 3 && checkInsuranceCompanies() !== 2 && checkInsuranceCompanies() !== 1) {
            return true
        } else {
            return false
        }
    }

    const checkFields = (e) => {
        let lname = checkLastname()
        let name = checkName()
        let patr = checkPatronymic()
        let sex = checkSex()
        let bdate = checkBirthDate()
        let iss = checkIssuedBy()
        let regadr = checkRegAdr()
        let subdiv = checkSubdiv()
        let issdate = checkIssueDate()
        let serial = checkSerial()
        let height = checkHeight()
        let weight = checkWeight()
        let corrdate = checkDates()

        if (lname === 1 && name === 1 &&
            patr === 1 && sex === 1 &&
            bdate === 1 && iss === 1 &&
            regadr === 1 && subdiv === 1 &&
            issdate === 1 && serial === 1 &&
            height === 1 && weight === 1 && corrdate === 1) {
            return true
        } else {
            return false
        }

    }


    const handleChangeBirthDate = (e) => {
        dispatch(setBirthDateString(e.target.value))
    }

    const handleChangeLastname = (e) => {
        dispatch(setLastname(e.value))
    }

    const handleChangeName = (e) => {
        dispatch(setName(e.value))
    }

    const handleChangePatronymic = (e) => {
        dispatch(setPatronymic(e.value))
    }


    const handleChangeSerial = (e) => {
        dispatch(setSerial(e.target.value))
    }


    const handleChangeHeight = (e) => {
        dispatch(setHeight(e.target.value))
    }


    const handleChangeWeight = (e) => {
        dispatch(setWeight(e.target.value))
    }


    const handleChangeIssueDate = (e) => {
        dispatch(setIssueDateString(e.target.value))
    }


    const handleChangeSubdivision = (e) => {
        dispatch(setSubdivision(e.target.value))
    }


    const handleChangeIssuedBy = (e) => {
        setIssueBuyCorrect(true)
        dispatch(setIssuedBy(e.target.value))
    }


    const handleChangeRegAdr = (e) => {
        dispatch(setKladrIdRegAddr(e.data.kladr_id))
        dispatch(setFiasIdRegAddr(e.data.fias_id))
        dispatch(setRegAdr(e.value))
    }


    const handleChangeWorkingPlace = (e) => {
        dispatch(setWorkingPlace(e.target.value))
    }
    const workingPlace = useSelector(selectWorkingPlace)

    const handleChangePosition = (e) => {
        dispatch(setPosition(e.target.value))
    }
    const position = useSelector(selectPosition)

    const handleChangeProfession = (e) => {
        dispatch(setProfession(e.target.value))
    }
    const profession = useSelector(selectProfession)

    return (
        <>
            <div class="calculator-tab-body-blok calculator-tab-body-blok-2">
                <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-2">
                    Данные  заемщика
                    <span>(на кого оформляется полис)</span>
                </p>
                <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-21">
                    Данные заемщика
                    <span>(на кого оформляется полис)</span>
                </p>
                <div name="contact_form" class="tab-body-blok-info tab-body-blok-info-2 my-form"
                    id="tab-body-blok-info-2">
                    <div class="tab-body-blok-info-row tab-body-blok-info-row-1">
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-1">
                            <div className={"tab-body-blok-info-element-vnutr " + (emptyLastname ? "" : "redBorder")}>
                                <label className="section-two-banks-text-2" htmlFor="pet-select">Фамилия</label>
                                {/* <input className="pole pole-step-2" id="pole-1.1" name="surname" type="text"
                                    value={lastname} placeholder="-" required onChange={handleChangeLastname} /> */}
                                <FioSuggestions
                                    inputProps={{
                                        className: "pole pole-step-2 addr_sugg",
                                        id: 'lastname'
                                    }}
                                    defaultQuery={lastname}
                                    token="93bd729e5209d96326b970b0f8cdd5f0ce2ef6bd"
                                    value={lastname}
                                    onChange={handleChangeLastname} />

                            </div>
                        </div>
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-2">
                            <div className={"tab-body-blok-info-element-vnutr" + (emptyName ? "" : " redBorder")}>
                                <label className="section-two-banks-text-2" htmlFor="pet-select">Имя</label>
                                {/* <input className="pole pole-step-2" id="pole-1.2" name="name" type="text"
                                    value={name} placeholder="-" required onChange={handleChangeName} /> */}
                                <FioSuggestions
                                    inputProps={{
                                        className: "pole pole-step-2 addr_sugg",
                                        id: 'name'
                                    }}
                                    defaultQuery={name}
                                    token="93bd729e5209d96326b970b0f8cdd5f0ce2ef6bd"
                                    value={name}
                                    onChange={handleChangeName} />
                            </div>
                        </div>
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-3">
                            <div className={"tab-body-blok-info-element-vnutr" + (emptyPatr ? "" : " redBorder")}>
                                <label className="section-two-banks-text-2"
                                    htmlFor="pet-select">Отчество</label>
                                {/* <input className="pole pole-step-2" id="pole-1.3" name="patronymic"
                                    type="text" value={patronymic} placeholder="-" required onChange={handleChangePatronymic} /> */}
                                <FioSuggestions
                                    inputProps={{
                                        className: "pole pole-step-2 addr_sugg",
                                        id: 'parentname'
                                    }}
                                    defaultQuery={patronymic}
                                    token="93bd729e5209d96326b970b0f8cdd5f0ce2ef6bd"
                                    value={patronymic}
                                    onChange={handleChangePatronymic} />
                            </div>
                        </div>
                    </div>
                    <div class="tab-body-blok-info-row tab-body-blok-info-row-2">
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-4">
                            <div className={"tab-body-blok-info-element-vnutr" + ((emptyDate && correctBirthDate) ? "" : " redBorder")}>
                                <label className="section-two-banks-text-2" htmlFor="pet-select">
                                    Дата рождения
                                </label>
                                <InputMask mask="99.99.9999"
                                    placeholder="ДД.ММ.ГГГГ"
                                    className="pole pole-step-2 mask-date "

                                    value={birthDateString}
                                    onChange={handleChangeBirthDate} />
                            </div>
                        </div>
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-5">
                            <div className="form-1-col form-1-col-1">
                                <div className={"tab-body-blok-info-element-vnutr" + (emptyGender ? "" : " redBorder")}>
                                    <UniversalDropDown listOf={listGender}
                                        setFunc={setSex}
                                        selectFunc={selectSex}
                                        title="Пол" />
                                </div>
                            </div>
                        </div>
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-6">
                            <div className={"tab-body-blok-info-element-vnutr" + (emptyHeight ? "" : " redBorder")}>
                                <label className="section-two-banks-text-2" htmlFor="pet-select">Рост</label>
                                <input className="pole pole-step-2 mask-rost " id="pole-1.6"
                                    disabled={!lifeOption}
                                    name="ostatok" type="text" value={height} onChange={handleChangeHeight}
                                    placeholder="-" />
                            </div>
                        </div>
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-7">
                            <div className={"tab-body-blok-info-element-vnutr" + (emptyWeight ? "" : " redBorder")}>
                                <label className="section-two-banks-text-2" htmlFor="pet-select">Вес</label>
                                <input className="pole pole-step-2 mask-ves " id="pole-1.7"
                                    disabled={!lifeOption}
                                    name="ostatok" type="text" value={weight} onChange={handleChangeWeight}
                                    placeholder="-" />
                            </div>
                        </div>
                        <div class="tab-body-blok-info-element tab-body-blok-info-element-8">
                            <div class="tab-body-blok-info-element-vnutr">
                                <label class="section-two-banks-text-2"
                                    for="pet-select">Документ</label>
                                {/* <input class="pole pole-step-2" id="pole-1.8" name="ostatok" type="text"
                                    value="ы" placeholder="Паспорт" /> */}
                                <div class="pole pole-step-2 t_a_l">Паспорт</div>
                            </div>
                        </div>
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-9">
                            <div className={"tab-body-blok-info-element-vnutr" + (emptySerial ? "" : " redBorder")}>
                                <label className="section-two-banks-text-2" htmlFor="pet-select">Серия и
                                    номер</label>
                                <InputMask mask="9999 999999"
                                    placeholder="---- ------"
                                    className="pole pole-step-2 mask-date "
                                    id="pole-1.9"
                                    name="ostatok"
                                    value={serial}
                                    onChange={handleChangeSerial}
                                />
                            </div>
                        </div>
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-10">
                            <div className={"tab-body-blok-info-element-vnutr" + ((emptyDateIss && correctIssueDate) ? "" : " redBorder")}>
                                <label className="section-two-banks-text-2" htmlFor="pet-select">Дата выдачи
                                    паспорта</label>
                                <InputMask mask="99.99.9999"
                                    placeholder="ДД.ММ.ГГГГ"
                                    className="pole pole-step-2 mask-date "
                                    id="pole-1.10"
                                    name="ostatok"
                                    value={issueDateString}
                                    onChange={handleChangeIssueDate}
                                />
                            </div>
                        </div>
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-11">
                            <div className={"tab-body-blok-info-element-vnutr" + (emptySubdiv ? "" : " redBorder")}>
                                <label className="section-two-banks-text-2" htmlFor="pet-select">Код
                                    подразделения</label>
                                <InputMask mask="999 999"
                                    placeholder="--- ---"
                                    className="pole pole-step-2 mask-date "
                                    id="pole-1.11"
                                    name="ostatok"
                                    value={subdivision}
                                    onChange={handleChangeSubdivision}
                                />
                            </div>
                        </div>
                    </div>
                    <div class="tab-body-blok-info-row tab-body-blok-info-row-3">
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-12">
                            <div className={"tab-body-blok-info-element-vnutr" + (emptyIss ? "" : " redBorder")}>
                                <label className="section-two-banks-text-2" htmlFor="pet-select">Кем
                                    выдан</label>
                                <input className="pole pole-step-2" id="pole-1.12" name="ostatok"
                                    type="text" value={issuedBy} placeholder="МВД..." onChange={handleChangeIssuedBy} />
                            </div>
                        </div>
                        <div className="tab-body-blok-info-element tab-body-blok-info-element-13">
                            <div className={"tab-body-blok-info-element-vnutr" + (emptyAddress && addressQsymCorrect ? "" : " redBorder")}>
                                <label className="section-two-banks-text-2" htmlFor="pet-select">Адрес
                                    регистрации</label>
                                <div>
                                    <AddressSuggestions
                                        inputProps={{
                                            className: "pole pole-step-2 addr_sugg"
                                        }}
                                        defaultQuery={regAdr}
                                        token="93bd729e5209d96326b970b0f8cdd5f0ce2ef6bd"
                                        value={regAdr}
                                        onChange={handleChangeRegAdr} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {checkInsuranceCompanies() === 1 &&
                        <div class="tab-body-blok-info tab-body-blok-info-3" id="tab-body-blok-info-3-1">
                            <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-2">
                                Страховая компания запрашивает дополнительные данные:
                            </p>
                            <div class="tab-body-blok-info-row tab-body-blok-info-row-4">
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-14">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listPreassureUp}
                                                setFunc={setArteryUp}
                                                selectFunc={selectArteryUp}
                                                title="Артериальное давление верхнее" />
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-15">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listPreassureBot}
                                                setFunc={setArteryBott}
                                                selectFunc={selectArteryBott}
                                                title="Артериальное давление нижнее" />
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-16">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listSmoking}
                                                setFunc={setSmoking}
                                                selectFunc={selectSmoking}
                                                title="Курение" />
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-17">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listAlcohol}
                                                setFunc={setAlcohol}
                                                selectFunc={selectAlcohol}
                                                title="Алкоголь" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-body-blok-info-row tab-body-blok-info-row-5">
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-18">
                                    <div class={"tab-body-blok-info-element-vnutr" + (emptyWorkingPlace ? "" : " redBorder")}>
                                        <label class="section-two-banks-text-2" for="pet-select">Место
                                            работы</label>
                                        <input class="pole pole-step-2" name="ostatok" type="text" value={workingPlace} onChange={handleChangeWorkingPlace}
                                            placeholder="OOO" />
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-19 p-r">
                                    <div class="tab-body-blok-info-element-vnutr">
                                        <UniversalDropDown listOf={JOBS}
                                            setFunc={setPosition}
                                            selectFunc={selectPosition}
                                            title="Должность" />
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-20 p-r">
                                    <div class="tab-body-blok-info-element-vnutr">
                                        <UniversalDropDown listOf={profs}
                                            setFunc={setProfession}
                                            selectFunc={selectProfession}
                                            title="Профессия" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {checkInsuranceCompanies() === 2 &&
                        <div class="tab-body-blok-info tab-body-blok-info-3" id="tab-body-blok-info-3-2">
                            <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-2">
                                Страховая компания запрашивает дополнительные данные:
                            </p>
                            <div class="tab-body-blok-info-row tab-body-blok-info-row-4">
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-14">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listPreassureUp}
                                                setFunc={setArteryUp}
                                                selectFunc={selectArteryUp}
                                                title="Артериальное давление верхнее" />
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-15">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listPreassureBot}
                                                setFunc={setArteryBott}
                                                selectFunc={selectArteryBott}
                                                title="Артериальное давление нижнее" />
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-16">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listSmoking}
                                                setFunc={setSmoking}
                                                selectFunc={selectSmoking}
                                                title="Курение" />
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-17">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listAlcohol}
                                                setFunc={setAlcohol}
                                                selectFunc={selectAlcohol}
                                                title="Алкоголь" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-body-blok-info-row tab-body-blok-info-row-4-1">
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-16-1">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listIsNewestBuilding}
                                                setFunc={setIsNewest}
                                                selectFunc={selectIsNewest}
                                                title="Новостройка" />
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-17-1">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listIsPublicPerson}
                                                setFunc={setIsPublicPerson}
                                                selectFunc={selectIsPublicPerson}
                                                title="Публичное лицо" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-body-blok-info-row tab-body-blok-info-row-5">
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-18">
                                    <div class={"tab-body-blok-info-element-vnutr" + (emptyWorkingPlace ? "" : "redBorder")}>
                                        <label class="section-two-banks-text-2" for="pet-select">Место
                                            работы</label>
                                        <input class="pole pole-step-2" name="ostatok" type="text" value={workingPlace} onChange={handleChangeWorkingPlace}
                                            placeholder="OOO" />
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-19 p-r">
                                    <div class="tab-body-blok-info-element-vnutr">
                                        <UniversalDropDown listOf={JOBS}
                                            setFunc={setPosition}
                                            selectFunc={selectPosition}
                                            title="Должность" />
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-20 p-r">
                                    <div class="tab-body-blok-info-element-vnutr">
                                        <UniversalDropDown listOf={profs}
                                            setFunc={setProfession}
                                            selectFunc={selectProfession}
                                            title="Профессия" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {checkInsuranceCompanies() === 3 &&
                        <div class="tab-body-blok-info tab-body-blok-info-3" id="tab-body-blok-info-3-3">
                            <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-2">
                                Страховая компания запрашивает дополнительные данные:
                            </p>
                            <div class="tab-body-blok-info-row tab-body-blok-info-row-4-1"
                                id="tab-body-blok-info-row-4-1">
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-16-1">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listIsPublicPerson}
                                                setFunc={setIsPublicPerson}
                                                selectFunc={selectIsPublicPerson}
                                                title="Публичное лицо" />
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-17-1">
                                    <div class="form-1-col form-1-col-1">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <UniversalDropDown listOf={listIsNewestBuilding}
                                                setFunc={setIsNewest}
                                                selectFunc={selectIsNewest}
                                                title="Новостройка" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div>
                        <div type="submit" className={"button button-" + (status ? "1 button-novostroiki-1 button-step-23" : "1 button-novostroiki-2 button-step-23")}
                            id="button-step-23" value="Далее" onClick={() => { handleClickNext() }
                            }
                        >
                            Далее
                        </div>

                        {!status &&
                            <div className="validacia">
                                <p id="validacia-text"
                                    className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                    Заполните все поля</p>
                            </div>
                        }
                        {!cyrylic &&
                            <div className="validacia">
                                <p id="validacia-text"
                                    className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                    ФИО вводится кириллицей</p>
                            </div>
                        }
                        {!age &&
                            <div className="validacia">
                                <p id="validacia-text"
                                    className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                    Разница между датой рождения и датой получения паспорта должна быть минимум 14 лет!</p>
                            </div>
                        }
                        {!issueBuyCorrect &&
                            <div className="validacia">
                                <p id="validacia-text"
                                    className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                    Количество символов в поле Кем выдан должно быть больше 5</p>
                            </div>
                        }

                        {!addressQsymCorrect &&
                            <div className="validacia">
                                <p id="validacia-text"
                                    className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                    Количество символов в поле адрес должно быть больше 9</p>
                            </div>
                        }
                        {(!correctBirthDate || !correctIssueDate) &&
                            <div className="validacia">
                                <p id="validacia-text"
                                    className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                    Некорректная дата</p>
                            </div>
                        }

                    </div>
                </div>
            </div>
        </>
    );
}



